<template>
  <!-- <div v-if="loadingState">loading...</div> -->
  <v-data-table
    :headers="headers"
    :items="items"
    sort-by="ID"
    :loading="loadingState"
    :search="search"
    multi-sort
    class="elevation-1"
    :footer-props="{
      showFirstLastPage: true,
      itemsPerPageText: 'Elemente pro Seite:',
      itemsPerPageAllText: 'Alle',
    }"
  >
    <template #[`footer.page-text`]="items">
      {{ items.pageStart }} - {{ items.pageStop }} / {{ items.itemsLength }}
    </template>
    <template #top>
      <v-toolbar flat dense short>
        <v-toolbar-title>{{ name }}</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Suche"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-btn color="primary" x-small fab @click="initialize">
          <v-icon medium>mdi-reload</v-icon>
        </v-btn>
        <v-divider vertical inset></v-divider>
        <v-dialog v-model="dialog" max-width="500px">
          <template #activator="{ on, attrs }">
            <v-btn color="primary" x-small fab v-bind="attrs" v-on="on">
              <v-icon medium>mdi-plus</v-icon>
            </v-btn>
          </template>

          <v-card>
            <v-card-title>
              <span v-if="editedItem !== -1" class="headline">{{
                formTitle
              }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col>
                    <v-text-field
                      v-model="editedItem.name"
                      label="Name"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="close">Abbrechen</v-btn>
              <v-btn color="primary" text @click="save">Speichern</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template #[`item.CreatedAt`]="{ item }">
      <!-- eslint-disable-next-line vue/no-deprecated-filter -->
      {{ item.CreatedAt | formatTimeString }}
    </template>
    <template #[`item.UpdatedAt`]="{ item }">
      <!-- eslint-disable-next-line vue/no-deprecated-filter -->
      {{ item.UpdatedAt | formatTimeString }}
    </template>
    <template #[`item.actions`]="{ item }">
      <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
      <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
    </template>
    <template #no-data>
      <v-btn color="primary" @click="initialize">Aktualisieren</v-btn>
    </template>
  </v-data-table>
</template>

<script>
import { mapGetters } from "vuex";
import Swal from "sweetalert2";
export default {
  name: "RolesTable",
  data: () => ({
    name: "Rollen",
    search: "",
    dialog: false,
    headers: [
      { text: "ID", align: "start", value: "ID" },
      { text: "Erstellt", value: "CreatedAt" },
      { text: "Aktualisiert", value: "UpdatedAt" },
      { text: "Name", value: "name" },
      { text: "Aktionen", value: "actions", sortable: false },
    ],
    editedIndex: -1,
    editedItem: {},
    defaultItem: {
      id: null,
      name: "",
    },
  }),
  computed: {
    ...mapGetters("roles", {
      loadingState: "loadingState",
      items: "items",
    }),
    formTitle() {
      return this.editedIndex === -1
        ? "Neu"
        : "Bearbeiten" + " | ID: " + this.editedItem.ID;
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  mounted() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.$store.dispatch("roles/updateData");
    },
    editItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    async deleteItem(item) {
      const index = this.items.indexOf(item);

      await Swal.fire({
        title: "Sicher, dass dieses Element gelöscht werden soll?",
        showDenyButton: true,
        confirmButtonText: `Löschen`,
        denyButtonText: `Abbrechen`,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store.dispatch("roles/delete", item);
          this.items.splice(index, 1);
          Swal.fire("Gelöscht!", "", "success");
        } else if (result.isDenied) {
          Swal.fire("Das Element wurde nicht gelöscht.", "", "info");
          return true;
        }
      });
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.items[this.editedIndex], this.editedItem);
        this.$store.dispatch("roles/update", this.editedItem);
      } else {
        this.$store.dispatch("roles/add", this.editedItem);
      }
      this.close();
    },
  },
};
</script>
